<template>
  <div class="home">
    <section id="video" class="mb-1">
      <video-player
        :options="homeVideo"
        class="vjs-default-skin vjs-big-play-centered"
      />
    </section>
    <section id="equipo" class="container is-fluid mb-1 top-section">
      <Team />
    </section>
    <section id="metodologia" class="hero is-dark top-section">
      <div class="hero-body">
        <div class="container">
          <h2 class="title">
            Metodología /
          </h2>
          <p class="text-big">
            Te ayudamos a definir qué, cómo, cuándo, dónde y a quién comunicar;
            planeando objetivos claros, y llevamos a cabo acciones estratégicas,
            creativas e innovadoras para apoyarte de manera eficaz y rentable en
            el diseño e implementación de tus campañas.
          </p>
          <video-player :options="methodVideo" />
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped lang="scss">
.hero.is-dark {
  .title {
    font-size: 32px;
    color: #f7d500;
  }
}
.hero-body {
  padding: 2rem 3rem;

  p {
    padding: 1rem 15%;
  }

  .text-big {
    font-size: 15px;
  }
}
</style>

<script>
import VideoPlayer from "@/components/VideoPlayer.vue";
import Team from "@/components/Team.vue";

export default {
  name: "home",
  components: {
    VideoPlayer,
    Team
  },
  data() {
    return {
      homeVideo: {
        poster: require("@/assets/videos/Sixthsense_Credenciales_Sentidos.jpg"),
        sources: [
          {
            src: require("@/assets/videos/Sixthsense_Credenciales_Sentidos.mp4"),
            type: "video/mp4"
          }
        ]
      },
      methodVideo: {
        autoplay: true,
        muted: true,
        loop: true,
        controls: false,
        poster: require("@/assets/videos/Loop_de_Metodologia_Sixthsense.jpg"),
        sources: [
          {
            src: require("@/assets/videos/Loop_de_Metodologia_Sixthsense.mp4"),
            type: "video/mp4"
          }
        ]
      }
    };
  }
};
</script>
